var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatListBulleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -729.080078125 592 498.16009521484375",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.62-260v-32H776v32zm0-204v-32H776v32zm0-204v-32H776v32zM228.86-230.92q-18.68 0-31.77-13.31Q184-257.53 184-276.21t13.3-31.78q13.31-13.09 31.99-13.09t31.77 13.31q13.09 13.3 13.09 31.98t-13.3 31.78q-13.3 13.09-31.99 13.09m0-204q-18.68 0-31.77-13.31Q184-461.53 184-480.21t13.3-31.78q13.31-13.09 31.99-13.09t31.77 13.31q13.09 13.3 13.09 31.98t-13.3 31.78q-13.3 13.09-31.99 13.09m0-204q-18.68 0-31.77-13.31Q184-665.53 184-684.21t13.3-31.78q13.31-13.09 31.99-13.09t31.77 13.31q13.09 13.3 13.09 31.98t-13.3 31.78q-13.3 13.09-31.99 13.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListBulleted);
export default __webpack_public_path__ + "static/media/format_list_bulleted.c715ca2208efdb4f14cee495b9bf94de.svg";
export { ForwardRef as ReactComponent };